import React from "react";
//import { Map, GoogleApiWrapper, Marker } from "google-maps-react";
import { PropTypes } from "prop-types";
//import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
const FooterMap = props => {
  const mapStyles = {
    width: "200&",
    height: "100%"
  };

  var informazioni = global.informazioni
  
  const position = [props.latitude, props.longitude]
  return (
    <div>
        <iframe src={informazioni.iframeLocation} width="100%" height = "500" style={{border:"0"}} allowfullscreen="" loading="lazy"></iframe>

    </div>
    
  );
};

FooterMap.propTypes = {
  google: PropTypes.object,
  latitude: PropTypes.string,
  longitude: PropTypes.string
};

/*export default GoogleApiWrapper({
  apiKey: "AIzaSyBUfHRjiHo-Qyx_jeAVxQLYUmACMtYKRcg"
})(FooterMap);*/
export default FooterMap;